/** Filter row above a table. */
const Toolbar = ({ children }) => <div className="toolbar">{children}</div>;

export default Toolbar;
